import { render } from "./AddPersonQuiz.vue?vue&type=template&id=519ef1aa&scoped=true"
import script from "./AddPersonQuiz.vue?vue&type=script&lang=js"
export * from "./AddPersonQuiz.vue?vue&type=script&lang=js"

import "./AddPersonQuiz.vue?vue&type=style&index=0&id=519ef1aa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-519ef1aa"]])

export default __exports__